import * as i0 from '@angular/core';
import { Injectable, Optional, Directive, Input, Component, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
function IconSpriteComponent_ng_container_0__svg_title_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "title");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r0.src.split("#")[1] + "-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function IconSpriteComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg");
    i0.ɵɵtemplate(2, IconSpriteComponent_ng_container_0__svg_title_2_Template, 2, 2, "title", 0);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("class", ctx_r0.classes)("width", ctx_r0.width)("height", ctx_r0.height || ctx_r0.width);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.title && ctx_r0.src);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.src, null, "xlink");
  }
}
function IconSpriteComponent_ng_container_1__svg_title_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "title");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r0.src.split("#")[1] + "-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function IconSpriteComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 1);
    i0.ɵɵtemplate(2, IconSpriteComponent_ng_container_1__svg_title_2_Template, 2, 2, "title", 0);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("attribute", ctx_r0.attribute);
    i0.ɵɵattribute("class", ctx_r0.classes)("width", ctx_r0.width)("height", ctx_r0.height || ctx_r0.width);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.title && ctx_r0.src);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.src, null, "xlink");
  }
}
function IconSpriteComponent_ng_container_2__svg_title_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "title");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r0.src.split("#")[1] + "-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function IconSpriteComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg");
    i0.ɵɵtemplate(2, IconSpriteComponent_ng_container_2__svg_title_2_Template, 2, 2, "title", 0);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("class", ctx_r0.classes)("width", ctx_r0.width)("height", ctx_r0.height || ctx_r0.width)("viewBox", ctx_r0.viewBox)("preserveAspectRatio", ctx_r0.preserveAspectRatio);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.title && ctx_r0.src);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.src, null, "xlink");
  }
}
function IconSpriteComponent_ng_container_3__svg_title_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "title");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("id", ctx_r0.src.split("#")[1] + "-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function IconSpriteComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 1);
    i0.ɵɵtemplate(2, IconSpriteComponent_ng_container_3__svg_title_2_Template, 2, 2, "title", 0);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("attribute", ctx_r0.attribute);
    i0.ɵɵattribute("class", ctx_r0.classes)("width", ctx_r0.width)("height", ctx_r0.height || ctx_r0.width)("viewBox", ctx_r0.viewBox)("preserveAspectRatio", ctx_r0.preserveAspectRatio);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.title && ctx_r0.src);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.src, null, "xlink");
  }
}
class IconSpriteConfig {
  path;
}

/**
 * To access a global sprite path
 */
let IconSpriteService = /*#__PURE__*/(() => {
  class IconSpriteService {
    spritePath;
    constructor(config) {
      if (config) {
        this.setPath(config.path);
      }
    }
    setPath(path) {
      this.spritePath = path;
    }
    getPath() {
      return this.spritePath;
    }
    /** @nocollapse */
    static ɵfac = function IconSpriteService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconSpriteService)(i0.ɵɵinject(IconSpriteConfig, 8));
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IconSpriteService,
      factory: IconSpriteService.ɵfac,
      providedIn: 'root'
    });
  }
  return IconSpriteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Set your own attribute key/value pairs on the generated SVG element, i.e. focusable="false"
 */
let IconSpriteDirective = /*#__PURE__*/(() => {
  class IconSpriteDirective {
    renderer;
    el;
    attribute;
    constructor(renderer, el) {
      this.renderer = renderer;
      this.el = el;
    }
    ngOnInit() {
      if (Array.isArray(this.attribute[0])) {
        const attributeArr = this.attribute;
        attributeArr.forEach(obj => {
          this.renderer.setAttribute(this.el.nativeElement, obj[0], obj[1] ? obj[1] : '');
        });
      } else {
        const attribute = this.attribute;
        if (attribute[0]) {
          this.renderer.setAttribute(this.el.nativeElement, attribute[0], attribute[1] ? attribute[1] : '');
        }
      }
    }
    /** @nocollapse */
    static ɵfac = function IconSpriteDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconSpriteDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: IconSpriteDirective,
      selectors: [["", "svgIconSpriteAttr", ""]],
      inputs: {
        attribute: "attribute"
      },
      standalone: false
    });
  }
  return IconSpriteDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconSpriteComponent = /*#__PURE__*/(() => {
  class IconSpriteComponent {
    iconSpriteService;
    src;
    classes = 'icon';
    width = '100%';
    height;
    viewBox;
    preserveAspectRatio = 'xMinYMax meet';
    attribute;
    title;
    constructor(iconSpriteService) {
      this.iconSpriteService = iconSpriteService;
    }
    ngOnChanges(changes) {
      // If the src does not contain a # and a spritePath is set via the service, concatenate them
      if (this.src && !this.src.includes('#') && this.iconSpriteService.spritePath) {
        this.src = `${this.iconSpriteService.getPath()}#${this.src}`;
      }
    }
    /** @nocollapse */
    static ɵfac = function IconSpriteComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconSpriteComponent)(i0.ɵɵdirectiveInject(IconSpriteService));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IconSpriteComponent,
      selectors: [["svg-icon-sprite"]],
      inputs: {
        src: "src",
        classes: "classes",
        width: "width",
        height: "height",
        viewBox: "viewBox",
        preserveAspectRatio: "preserveAspectRatio",
        attribute: "attribute",
        title: "title"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 4,
      consts: [[4, "ngIf"], ["svgIconSpriteAttr", "", 3, "attribute"]],
      template: function IconSpriteComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, IconSpriteComponent_ng_container_0_Template, 4, 5, "ng-container", 0)(1, IconSpriteComponent_ng_container_1_Template, 4, 6, "ng-container", 0)(2, IconSpriteComponent_ng_container_2_Template, 4, 7, "ng-container", 0)(3, IconSpriteComponent_ng_container_3_Template, 4, 8, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.viewBox && !ctx.attribute);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.viewBox && ctx.attribute);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.viewBox && !ctx.attribute);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.viewBox && ctx.attribute);
        }
      },
      dependencies: [i2.NgIf, IconSpriteDirective],
      styles: ["[_nghost-%COMP%]   use[_ngcontent-%COMP%], [_nghost-%COMP%]   svg[_ngcontent-%COMP%]{fill:currentColor}"]
    });
  }
  return IconSpriteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Using forRoot({ path: 'filepath' }), this module can be provided as a
 * singleton for the global application (including lazy loaded submodules).
 */
let IconSpriteModule = /*#__PURE__*/(() => {
  class IconSpriteModule {
    static forRoot(config) {
      return {
        ngModule: IconSpriteModule,
        providers: [{
          provide: IconSpriteConfig,
          useValue: config
        }]
      };
    }
    /** @nocollapse */
    static ɵfac = function IconSpriteModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconSpriteModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: IconSpriteModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return IconSpriteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of icon-sprite
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IconSpriteComponent, IconSpriteConfig, IconSpriteModule, IconSpriteService };
